<script setup lang="ts">
  import { computed, useId } from 'vue';
  import {
    itemListClass,
    itemListRootClass,
    itemListTitleClass,
  } from './ItemList.css';
  import type { ItemListProps } from './ItemList.types';

  const props = defineProps<ItemListProps>();

  const uid = useId();
  const resolvedTestId = computed(() => props.testId ?? `ds-item-list-${uid}`);
  const titleId = computed(() =>
    props.title ? `${resolvedTestId.value}-title` : undefined,
  );
</script>

<template>
  <div :class="itemListRootClass" :data-testid="resolvedTestId">
    <span
      v-if="title"
      :id="`${resolvedTestId}-title`"
      :class="itemListTitleClass"
      :data-testid="`${resolvedTestId}-title`"
      >{{
        title
      }}</span
    >
    <!-- biome-ignore lint/a11y/noRedundantRoles: list-style:none makes Safari/VoiceOver drop list semantics; the explicit role restores them -->
    <ul :class="itemListClass" role="list" :aria-labelledby="titleId">
      <slot />
    </ul>
  </div>
</template>
